export default __webpack_public_path__ + "static/media/page2.051f3647.webp";